module.exports = "/_next/static/images/findus-duotone-9031aa0770822efa49bf78b834b7ab64.svg";